import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import {
    VenueType,
    getVenueTypeText,
    getVenueTypeClass,
} from 'utils/venueTypeUtils';
import { Tooltip } from '@instinet-analytics/core-lib';

export default function venueTypeCellRenderer({ data }: ICellRendererParams) {
    const venueType: VenueType = data.executionVenueType;

    return (
        <Tooltip text={getVenueTypeText(venueType)} showDelay={0}>
            <div className={`vt ${getVenueTypeClass(venueType)}`}>
                {data.executionVenueCode}
            </div>
        </Tooltip>
    );
}
